import axios from 'axios';

export const quotationApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-quotation`,
    headers: {
        'Content-Type': 'application/json'
    }
})